import { toggleSlider } from "./toggle-slider.animation";

export const animations: any[] = [
  toggleSlider,
];

export * from "./toggle-slider.animation";
